const PREFIX = "https://www.googleapis.com/auth/gmail.";

// Check capabilities, including broader grants and existing narrower grants.
export function hasGmailScope(scopeValue, expectedScope) {
  const requested = String(expectedScope || "").trim();
  if (!requested) return false;
  const scopes = String(scopeValue || "").split(/[\s,]+/).filter(Boolean);
  if (scopes.includes(requested)) return true;
  if (!["readonly", "send", "compose", "modify"].map(scope => `${PREFIX}${scope}`).includes(requested)) return false;
  if (scopes.includes("https://mail.google.com/") || scopes.includes(`${PREFIX}modify`)) return true;
  return requested === `${PREFIX}send` && scopes.includes(`${PREFIX}compose`);
}
